angular.module('mercury.modules.budget.worksheet')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Budget.Worksheet', {
    url: '/worksheet/:report',
    templateUrl: 'modules/budget/worksheet/worksheet.tpl.html',
    controller: 'BudgetWorksheetCtrl'
  });
}]);
